module.exports = __webpack_public_path__ + "img/re.7a9c1dcf.svg";